import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Zofran (Ondansetron) treatment type.
 */
export const ZofranTreatment = new TreatmentType({
  id: '12',
  name: ConsultationTreatmentTypes.Zofran,
  genderSettings: new TreatmentGenderSettings({
    excludedForUpsells: {
      '/consultation/be-prepared-for-the-unexpected': Gender.Male,
      '/consultation/mens-intimate-wash': Gender.Female,
    },
  }),
  eligibleTreatmentTypes: [{ id: 3233, name: UpsellSlugs.ZofranTreatmentDissolvableTabletUpsell }],
});
